// extracted by mini-css-extract-plugin
export var fullHeightState = "_5l-7";
export var headerCell = "_5l-1";
export var loadingStateCell = "_5l-4";
export var rowWrapper = "_5l-3";
export var standaloneTable = "_5l-8";
export var standaloneTableWithBodyFill = "_5l-9";
export var stateCell = "_5l-5";
export var table = "_5l-0";
export var tableBodyFiller = "_5l-6";
export var white = "_5l-2";